<mat-card appearance="raised">
  <mat-card-header class="mentorAssignment--right">
    <mat-card-title>Assigned Mentors</mat-card-title>

    @if (mentorCampusMisMatch) {
      <mat-card-subtitle class="mentorAssignment__campus__mismatch">The assigned Mentor's campus and Candidate's latest employment campus do not match, please end the current Mentor assignment.</mat-card-subtitle>
    }
    <!-- In Observations the Assign Mentor button will appear to the right, aligning with similar buttons -->
    @if (assignMentorButtonPosition == 'right') {
      <div>
        <button type="button" class="mentorAssignment--button" color="primary" mat-button mat-raised-button
          (click)="addNewMentorAssignment()"
          [disabled]="expandedMentorAssignmentRow || loadingMentorAssignments || disableMentorAssignment || !userRoleAllowedToModifyMentorAssignments"
          [matTooltip]="disableMentorAssignment ? 'Active employment required' : ''">
          <mat-icon class="mentorAssignment--button__icon">assignment_ind</mat-icon>
          Assign Mentor
        </button>
      </div>
    }
  </mat-card-header>

  <mat-card-content>
    <!-- In EPQ form the Assign Mentor button will appear in it's original location-->
    @if (assignMentorButtonPosition == 'left') {
      <div class="mentorAssignment--left">
        <button type="button" class="mentorAssignment--button" color="primary" mat-button mat-raised-button
          (click)="addNewMentorAssignment()"
          [disabled]="expandedMentorAssignmentRow || loadingMentorAssignments || disableMentorAssignment">
          <mat-icon class="mentorAssignment--button__icon">assignment_ind</mat-icon>
          Assign Mentor
        </button>
      </div>
    }

    <div class="no-assigned-mentors-message">
      @if (mentorAssignments.length === 0) {
        <span>A mentor has not been assigned</span>
      }
    </div>

    @if (mentorAssignments.length > 0) {
      <table mat-table [dataSource]="mentorAssignmentSource" multiTemplateDataRows>
        <ng-container matColumnDef="Campus">
          <th mat-header-cell *matHeaderCellDef>Campus</th>
          <td mat-cell *matCellDef="let mentorAssignment">
            {{mentorAssignment.CampusName}}
          </td>
        </ng-container>
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let mentorAssignment"
            [ngClass]="{'hyperlink-cell':mentorAssignment.Index != 0, 'normal-cell':mentorAssignment.Index === 0 || editingContact}">
            @if (mentorAssignment.Index != 0 && !editingContact) {
              <a (click)="editAssignedMentor(mentorAssignment)" matTooltip="Edit Mentor">{{mentorAssignment.FirstName}}
              {{mentorAssignment.LastName}}</a>
            }
            @if (mentorAssignment.Index == 0 || editingContact) {
              {{mentorAssignment.FirstName}} {{mentorAssignment.LastName}}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="Email">
          <th mat-header-cell *matHeaderCellDef class="mentor-email-cell">Email</th>
          <td mat-cell *matCellDef="let mentorAssignment">
            {{mentorAssignment.EmailAddress}}
          </td>
        </ng-container>
        <ng-container matColumnDef="MentorFee">
          <th mat-header-cell *matHeaderCellDef class="mentor-fee-cell">Mentor Fee</th>
          <td mat-cell *matCellDef="let mentorAssignment">
            {{mentorAssignment.MentorFee}}
          </td>
        </ng-container>
        <ng-container matColumnDef="StartDate">
          <th mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let mentorAssignment">
            {{mentorAssignment.AssignedOn | date: 'MM/dd/yyyy'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="EndDate">
          <th mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let mentorAssignment">
            {{mentorAssignment.EndDate | date: 'MM/dd/yyyy'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="NeedsPrincipalAttestation">
          <!-- This column will only show if the needsPrincipalAttestation checkbox is enabled in the component -->
          <th mat-header-cell *matHeaderCellDef>Needs Principal Attestation</th>
          <td mat-cell *matCellDef="let mentorAssignment">
            <a class="needs-principal-attestation-link"
              (click)="openDialog(mentorAssignment.NeedsPrincipalAttestation, mentorAssignment)"
              matTooltip="Edit Needs Principal Attestation">
              {{ mentorAssignment.NeedsPrincipalAttestation ? 'Yes' : 'No' }}
            </a>
          </td>
        </ng-container>
        <ng-container matColumnDef="EndAssignment">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let mentorAssignment">
            @if (mentorAssignment.Index != 0 && !mentorAssignment.EndDate) {
              <button type="button"
                class="mentorAssignment--button" mat-button mat-raised-button
                (click)="endMentorAssignment(mentorAssignment)">
                <mat-icon color="primary" class="mentorAssignment--end__button__icon">person_remove</mat-icon>
                End Assignment
              </button>
            }
          </td>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="mentorAssignmentEditor">
          <td class="mentorAssignmentFormContainer" mat-cell *matCellDef="let mentorAssignment;"
            [attr.colspan]="mentorsListColumns.length">
            <div class="mentor-assignment-editor-container"
              [@expandAnimation]="shouldShowRow(mentorAssignment.Index) && expandedMentorAssignmentRow ? 'expanded' : 'collapsed'">
              @if (!campusMentorListLoaded && !!selectedCampus && !editingContact) {
                <div>
                  <h4>Loading campus mentors...</h4>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              }
              <form [formGroup]="mentorAssignmentEditorForm">
                @if (!editingContact) {
                  <div class="formFields">
                    <div class="mentorListContainer">
                      <h4 class="mentorListContainer--label" for="mentorList">Campus Mentors</h4>
                      @if (!!selectedCampus) {
                        <div class="mentorListContainer--selectedCampusName">for
                        {{selectedCampus.name}}</div>
                      }
                      @if (!selectedCampus) {
                        <div>(no campus selected)</div>
                      }
                      @if (campusMentorListLoaded && campusMentorList && campusMentorList.length > 0) {
                        <mat-selection-list [multiple]="false" (selectionChange)="onMentorSelectionChanged($event)"
                          class="mentorList" formControlName="mentor" name="mentorList" id="mentorList"
                          hideSingleSelectionIndicator="true">
                          @for (mentor of campusMentorList; track mentor; let last = $last; let i = $index) {
                            <mat-list-option class="mentorListItem"
                              [value]="mentor.MentorId">
                              <div matListItemTitle>
                                <span class="mentorListItem--mentorName">{{mentor.DisplayName}}</span>
                              </div>
                              <span matListItemLine class="mentorListItem--mentorEmail">
                                <mat-icon matListItemIcon class="mentorListItem--mentorEmail__icon">mail</mat-icon>
                                @if (!!mentor.PrimaryEmail) {
                                  {{mentor.PrimaryEmail}}
                                }
                                @if (!mentor.PrimaryEmail) {
                                  <span class="missingEmailAddres">(no email address)</span>
                                }
                              </span>
                              <div matListItemLine class="list-row">
                                <span matListItemLine class="mentorListItem--teaId">State License ID: {{mentor.TEAId}}</span>
                                <mat-icon matListItemIcon class="edit-icon" (click)="editMentor(mentor)" color="primary"
                                matTooltip="edit">edit</mat-icon>
                              </div>
                              <div matListItemLine><span class="mentorListItem--certArea">Cert. Areas:
                              {{mentor.CertArea}}</span></div>
                            </mat-list-option>
                          }
                        </mat-selection-list>
                      }
                      @if ((!campusMentorList || campusMentorList.length == 0) && campusMentorListLoaded) {
                        <div class="noMentors"
                          >
                          <p class="noMentors--message">There are no mentor records for this campus.</p>
                        </div>
                      }
                      <div class="newMentorSection">
                        <button class="newMentorSection--button" mat-button mat-raised-button color="primary"
                          (click)="addNewMentor()">
                          Add New Campus Mentor
                        </button>
                        @if ((onlineSOE !== null && onlineSOE !== undefined && onlineSOE.mentorName) ||
                          (soeScan !== null && soeScan !== undefined && soeScan.mentorName)) {
                          <button class="newMentorSection--button" mat-button mat-raised-button color="primary"
                            (click)="importMentor()"
                            >
                            Import SOE Campus Mentor
                          </button>
                        }
                      </div>
                    </div>
                    @if (campusMentorListLoaded && campusMentorList) {
                      <div class="formFields--rightSide">
                        <div class="selectedCampusMentorFields">
                          <h2 class="formFields--contact-name">{{this.selectedMentor.DisplayName}}</h2>
                          <div class="formFields--rightSide--field">
                            <label>Email: </label>
                            <span><a href="mailto:{{this.selectedMentor.PrimaryEmail}}"
                            target="_blank">{{this.selectedMentor.PrimaryEmail}}</a></span>
                          </div>
                          <div class="formFields--rightSide--field">
                            <label>State License ID: </label>
                            <span>{{this.selectedMentor.TEAId}}</span>
                          </div>
                          <div class="formFields--rightSide--field">
                            <label>Title: </label>
                            <span>{{this.selectedMentor.Title}}</span>
                          </div>
                          <div class="formFields--rightSide--field">
                            <label>Cert Areas: </label>
                            <span>{{this.selectedMentor.CertArea}}</span>
                          </div>
                          <div class="formFields--rightSide--field">
                            <label>Phone: </label>
                            <span>{{this.selectedMentor.MainPhone}}</span>
                          </div>
                        </div>
                        <ng-template #notSelectedMentor>
                          <div class="selectedCampusMentorFields">
                            <p>Select a campus mentor from the list.</p>
                          </div>
                        </ng-template>
                        <div class="formFields--rightSide--field">
                          <mat-form-field class="startDateField">
                            <mat-label>Start Date</mat-label>
                            <input matInput [max]="today" [matDatepicker]="assignmentStartDatePicker"
                              placeholder="Start Date" formControlName="assignmentStartDate"
                              (dateChange)="onStartDateSelected($event)">
                              <mat-datepicker-toggle matSuffix [for]="assignmentStartDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #assignmentStartDatePicker></mat-datepicker>
                            </mat-form-field>
                            @if (showPrincipalAttestationCheckbox) {
                              <div class="needsPrincipalAttestationContainer">
                                <mat-checkbox [labelPosition]="after" color="warn" formControlName="needsPrincipalAttestation"
                                  id="needsPrincipalAttestation" name="needsPrincipalAttestation"
                                  matTooltip="This mentor assignment needs principal attestation to be completed."
                                  [disabled]="this.saving">
                                  Needs Principal Attestation
                                </mat-checkbox>
                                @if (selectedMentor.MentorId && !selectedMentorHasCertAreas) {
                                  <div class="missing__cert__Areas">
                                    Please fill in Mentor Cert Areas before selecting the Principal Attestation Checkbox
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          <div class="saveAndCancelButtons">
                            <button mat-button mat-raised-button color="primary" (click)="saveMentorAssignment()"
                              type="button"
                              [disabled]="mentorAssignmentEditorForm.controls.mentor.errors || mentorAssignmentEditorForm.controls.assignmentStartDate.errors || this.saving">
                              Assign
                            </button>
                            <button mat-button mat-raised-button color="accent" (click)="cancelMentorAssignment()"
                              type="button">
                              Cancel
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (editingContact) {
                    <div class="formFields--contactEditorContainer">
                      <app-campus-contact-editor [campusContactEditor]="campusContact" [profileId]="profileId"
                        (saveNewContact)="saveNewContact($event)" (updateContact)="updateContact($event)"
                        (cancelEvent)="cancelContactEditor(mentorAssignment.Index)">
                      </app-campus-contact-editor>
                    </div>
                  }
                </form>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="showPrincipalAttestationCheckbox ? mentorsListColumnsForTX : mentorsListColumns"></tr>
          <tr mat-row *matRowDef="let mentor; columns: showPrincipalAttestationCheckbox ? mentorsListColumnsForTX : mentorsListColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: ['mentorAssignmentEditor']" class="mentor-assignment-row"></tr>
        </table>
      }
    </mat-card-content>
    @if (loadingMentorAssignments || saving) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-card>
